import AddressInformation from './AddressInformation.component';

export default AddressInformation;
